import React, { useContext, useState, useEffect } from 'react';
import { Modal } from 'react-bootstrap';
import toast from 'react-hot-toast';

import { DataContext } from '../init/getData';
import Loader from '../components/loader/loader';
import { Button, Table, Divider } from 'antd';
import { Col, Form, Row, DropdownButton, Dropdown } from 'react-bootstrap';
import { dateTableFormatter } from '../dynamic/dateFormatter';
import { typeFormatter, paymentTypeFormatter, statusFormatter } from '../components/formatters/defFormatter';
import { numberFormatter } from '../components/formatters/numberFormatter';
import OpeningBalance from '../toolsTab/openingYear/tabs/openingBalance/openingBalance';

const EndSessionModal = (props) => {

  const { userData, sessionId, rateToMainCurrency, session, mainCurrency, localApi, serverApi, devData,
    rateMainToSecondaryCurrency, companyId, yearId, defaultCurrency } = useContext(DataContext);

  const createdBy = userData.id;
  const userName = userData.name;
  const userRole = userData.role;

  const { showModal, toggleModal, title, setAccess } = props;
  const [isLoading, setIsLoading] = useState(true);
  const [summary, setSummary] = useState(true);
  const [cashAccountBalance, setCashAccountBalance] = useState([]);
  const [closingBalanceInput, setClosingBalanceInput] = useState("");
  const [loadingEffect, setLoadingEffect] = useState(false);

  let api;
  if (devData?.isServer) {
    api = localApi;
  }
  else if (devData?.isOffline) {
    api = localApi;
  }
  else if (devData?.isClient) {
    api = serverApi;
  }
  const isUsingMainCurrency = defaultCurrency?.id == mainCurrency?.id ? true : false;

  const cashAccountId = userRole.cashAccountId;
  const varianceAccountId = userRole.varianceAccountId;

  const openingBalance = session?.openingBalance
  const secondaryOpeningBalance = session?.secondaryOpeningBalance;

  const balance = summary?.totalIn - summary?.totalOut;
  const secondaryBalance = summary?.secondaryTotalIn - summary?.secondaryTotalOut;

  const totalBalance = balance + parseFloat(openingBalance);
  const secondaryTotalBalance = secondaryBalance + parseFloat(secondaryOpeningBalance);

  const closingBalance = isUsingMainCurrency ? closingBalanceInput : rateToMainCurrency(defaultCurrency, closingBalanceInput);
  const secondaryClosingBalance = isUsingMainCurrency ? rateMainToSecondaryCurrency(closingBalanceInput) : closingBalanceInput;


  const cashAccountBalanceCurr = isUsingMainCurrency ? cashAccountBalance.balance : cashAccountBalance.secondaryBalance;

  let variance = parseFloat(totalBalance) - parseFloat(closingBalance);
  let secondaryVariance = secondaryTotalBalance - secondaryClosingBalance;


  const isDebit = variance > 0 ? true : false;

  variance = variance < 0 ? -variance : variance;
  secondaryVariance = secondaryVariance < 0 ? -secondaryVariance : secondaryVariance;

  let debit = isUsingMainCurrency ? variance : secondaryVariance;
  let credit = isUsingMainCurrency ? variance : secondaryVariance;

  let totalDebit = rateToMainCurrency(defaultCurrency, debit);
  let totalCredit = rateToMainCurrency(defaultCurrency, credit);

  let secondaryTotalCredit = rateMainToSecondaryCurrency(totalDebit);
  let secondaryTotalDebit = rateMainToSecondaryCurrency(totalCredit);

  const today = new Date().toISOString().split('T')[0];

  useEffect(() => {
    if (showModal) {
      fetchData();
    }
  }, [showModal]);

  useEffect(() => {
    setClosingBalanceInput(isUsingMainCurrency ? totalBalance : secondaryTotalBalance);
  }, [secondaryTotalBalance]);

  const fetchData = async () => {
    setIsLoading(true)
    const data = {
      sessionId,
      cashAccountId,
      yearId,
      companyId,
    }
    let res = await api.get("/session/view", { params: data });
    if (!res.data.status) {
      toast.error(res.data.message);
      setIsLoading(false)
    } else {
      setSummary(res?.data?.summary)
      setCashAccountBalance(res?.data?.cashAccountBalance)
      setIsLoading(false)
    }
  };

  const journalVoucher = {
    createdBy: createdBy,
    sessionId: sessionId,
    companyId: companyId,
    yearId: yearId,
    accountId: null,
    date: today,
    type: 'Variance',
    debit: debit,
    credit: credit,
    totalDebit: totalDebit,
    totalCredit: totalCredit,
    secondaryTotalDebit: secondaryTotalDebit,
    secondaryTotalCredit: secondaryTotalCredit,
    details: '',
    paymentType: 'cash',
    isDebit: isDebit,
    currencyId: defaultCurrency?.id,
    rate: defaultCurrency?.rate,

    branchId: userRole?.branchId,
  }


  const vDebit = isDebit ? debit : 0;
  const vCredit = !isDebit ? credit : 0;

  const vTotalDebit = rateToMainCurrency(defaultCurrency, vDebit);
  const vTotalCredit = rateToMainCurrency(defaultCurrency, vCredit);

  const vSecondaryTotalDebit = rateMainToSecondaryCurrency(vTotalDebit);
  const vSecondaryTotalCredit = rateMainToSecondaryCurrency(vTotalCredit);

  const transactions = [
    {
      type: 'Variance',
      accountId: varianceAccountId,
      isDebit: isDebit,
      debit: vDebit,
      credit: vCredit,
      totalDebit: vTotalDebit,
      totalCredit: vTotalCredit,
      secondaryTotalDebit: vSecondaryTotalDebit,
      secondaryTotalCredit: vSecondaryTotalCredit,
      rate: defaultCurrency?.rate,
      currencyId: defaultCurrency?.id,
    },

  ]

  const aDebit = !isDebit ? debit : 0;
  const aCredit = isDebit ? credit : 0;

  const aTotalDebit = rateToMainCurrency(defaultCurrency, aDebit);
  const aTotalCredit = rateToMainCurrency(defaultCurrency, aCredit);

  const aSecondaryTotalDebit = rateMainToSecondaryCurrency(aTotalDebit);
  const aSecondaryTotalCredit = rateMainToSecondaryCurrency(aTotalCredit);



  transactions.push({
    type: 'Account Payable',
    accountId: cashAccountId,
    isDebit: !isDebit,
    debit: aDebit,
    credit: aCredit,
    totalDebit: aTotalDebit,
    totalCredit: aTotalCredit,
    secondaryTotalDebit: aSecondaryTotalDebit,
    secondaryTotalCredit: aSecondaryTotalCredit,
    rate: defaultCurrency?.rate,
    currencyId: defaultCurrency?.id,
  })


   const handleSubmit = async () => {

    if (closingBalance == "" && closingBalance !== 0) {
      toast.error('please enter closing balance')
      return;
    }

    setLoadingEffect(true);

    try {
      if (devData.isOffline) {
        await getAllJv();
      } else {
        await endSession();
      }

    }
    catch (error) {
      toast.error("Error:", error);
      setLoadingEffect(false);
    }
  };

  const getAllJv = async () => {
    const data = {
      filter: {
        yearId,
        companyId,
        isOffline: devData.isOffline,
      }
    }
    let res = await api.get("/journalVoucher/getAll", { params: data });
    if (!res.data.status) {
      toast.error(res.data.message);
    } else {
      sendJvToServer(res.data.data);
    }

  };

  const sendJvToServer = async (data) => {

    let api;
    if (devData?.isServer) {
      api = localApi;
    }
    else if (devData?.isOffline) {
      api = serverApi;
    }
    else if (devData?.isClient) {
      api = serverApi;
    }


    let res = await api.post("/journalVoucher/addAll", data);
    if (!res.data.status) {
      toast.error(res.data.message);
    } else {
      toast.success(res.data.message);
      endSession(data)
    }

  };


  const endSession = async () => {
    const data = {
      journalVoucher,
      transactions,
      sessionId,
      closingBalance,
      secondaryClosingBalance,
      balance: totalBalance,
      secondaryBalance: secondaryTotalBalance,
      variance,
      secondaryVariance,
    }

    let api;
    if (devData?.isServer) {
      api = localApi;
    }
    else if (devData?.isOffline) {
      api = serverApi;
    }
    else if (devData?.isClient) {
      api = serverApi;
    }

    try {
      let res = await api.post("/session/end", data);
      if (!res.data.status) {
        toast.error(res.data.message);
      } else {
        toast.success(res.data.message);
        setAccess(false);
        if (devData.isOffline) {
          deleteAllSessionData();
        }
      }
    }
    catch (error) {
      toast.error("Error:", error);
    }

  };


  const deleteAllSessionData = async () => {
    const data = {
      sessionId,
    }

    let res = await localApi.post("/session/deleteSessionData", data);
    if (!res.data.status) {
      toast.error(res.data.message);
    } else {
      toast.success(res.data.message);
      setAccess(false);
    }

  };

  return (
    <Modal show={showModal} backdrop="static" size={'md'} keyboard={false} onHide={toggleModal}
      onKeyDown={(e) => { if (e.key === 'Enter') { e.preventDefault(); } }} >
      <Modal.Header style={{ background: "#eb5355" }}>
        <Modal.Title style={{ color: "white" }} >End Session</Modal.Title>
      </Modal.Header>

      {isLoading &&
        <div style={{ height: '20vh' }}>
          <Loader />
        </div>
      }

      {!isLoading &&
        <Modal.Body>

          <Row className="mb-2">
            <Col md={4}>
              <span style={{ fontWeight: 'bold' }}>
                Opening Balance:
              </span>
            </Col>
            <Col md={3}>
              <span style={{ fontWeight: 'bold', color: '#008000' }}>
                {numberFormatter(isUsingMainCurrency ? openingBalance : secondaryOpeningBalance)}{defaultCurrency?.symbol}
              </span>
            </Col>
          </Row>


          <Row className="mb-2">
            <Col md={4}>
              <span style={{ fontWeight: 'bold' }}>
                Session Balance:
              </span>
            </Col>
            <Col md={3}>
              <span style={{ fontWeight: 'bold', color: '#008000' }}>
                {numberFormatter(isUsingMainCurrency ? totalBalance : secondaryTotalBalance)}{defaultCurrency?.symbol}
              </span>
            </Col>
          </Row>


          <Row className="mb-4">
            <Col md={4}>
              <span style={{ fontWeight: 'bold' }}>
                Cash Balance:
              </span>
            </Col>
            <Col md={3}>
              <span style={{ fontWeight: 'bold', color: '#008000' }}>
                {numberFormatter(cashAccountBalanceCurr)}{defaultCurrency?.symbol}
              </span>
            </Col>
          </Row>

          <Row className="mb-4">
            <Col>
              <Form.Label>Balance {defaultCurrency.code}</Form.Label>
              <Form.Control type="number" step="any"
                onChange={e => setClosingBalanceInput(e.target.value)}
                value={closingBalanceInput}
                autoFocus />
            </Col>
          </Row>



          <Row className="mb-2">
            <Col md={4}>
              <span style={{ fontWeight: 'bold' }}>
                Variance:
              </span>
            </Col>
            <Col md={3}>
              <span style={{ fontWeight: 'bold', color: 'red' }}>
                {numberFormatter(isUsingMainCurrency ? variance : secondaryVariance)}{defaultCurrency?.symbol}
              </span>
            </Col>
          </Row>


          <Row className="mb-4">
            <Col md={4}>
              <span style={{ fontWeight: 'bold' }}>
                new Cash Balance:
              </span>
            </Col>
            <Col md={3}>
              <span style={{ fontWeight: 'bold', color: 'green' }}>
                {numberFormatter(isUsingMainCurrency ? cashAccountBalanceCurr - variance : cashAccountBalanceCurr - secondaryVariance)}{defaultCurrency?.symbol}
              </span>
            </Col>
          </Row>


          <div className="modal-footer" style={{ justifyContent: 'center' }}>
            <Button size="large" variant="filled" onClick={toggleModal}>Close</Button>

            <Button type="primary" size="large" loading={loadingEffect} onClick={handleSubmit}
              danger>End Session</Button>
          </div>

        </Modal.Body>
      }


    </Modal>
  )
}


export default EndSessionModal;